// Minimal stand-in for the seller-portal's cn() (clsx + tailwind-merge) —
// every call site this app actually has passes mutually-exclusive
// alternatives via ternaries, never genuinely conflicting Tailwind classes
// that need precedence resolution, so a plain filter+join is equivalent
// without pulling in two extra dependencies for one tiny helper.
export function cn(...inputs) {
  return inputs.filter(Boolean).join(" ");
}
